import React, { useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { getUserColor } from '../../../utils/index';
import useReadCookies from "../../hooks/useReadCookies";
import StarFX from "./subcomponents/starFX";

function Mission ({ lift, missionOnly, missionEnd, missionSuccess, showQuestion, miniGameActive }) 
{
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  let { cookiePlayerId } = useReadCookies();

  const [lifted, setLifted] = useState(false);

  let missionWrapperRef = useRef(null);
  let missionRef = useRef(null);
  let userOverviewRef = useRef(null);
  let missionOverviewRef = useRef(null);
  let timeOut = null;

  const [mainQuestionPlayerColor, setMainQuestionPlayerColor] = useState(null);
  const [mixNMatchPlayerColor, setMixNMatchPlayerColor] = useState(null);
  const [swipePlayerColor, setSwipePlayerColor] = useState(null);
  const [missionName, setMissionName] = useState(null);

  const players = useSelector((state) => state.game.players);
  const playerCount = useSelector((state) => state.game.playerCount);
  const currentMission = useSelector((state) => state.game.currentMission);
  const currentMissionData = useSelector((state) => state.game.missions[currentMission]);

  useEffect(() => {
    if(lift){
      setLifted(true);
    }
  }, [lift]);

  useEffect(() => {
    //console.log(miniGameActive)
  }, [miniGameActive]);

  useEffect(() => {
    let timeOut;
    if(currentMissionData !== undefined && !currentMissionData.finished){
      timeOut = setTimeout(() => {
        showQuestion(currentMissionData);
      }, 8000);
    }
    if(currentMissionData !== undefined && currentMissionData.finished){
      timeOut = setTimeout(() => {
        navigate('/app/game/overview' + window.location.search);
      }, 12000);
    }
  },[currentMissionData]);

  useEffect(() => {
    if(currentMissionData){
      setMainQuestionPlayerColor(getUserColor(currentMissionData.main_question_player));
      setMixNMatchPlayerColor(getUserColor(currentMissionData.mix_n_match_player));
      setSwipePlayerColor(getUserColor(currentMissionData.swipe_player));
      if(i18n.language === 'en'){
        setMissionName(currentMissionData.main_question.title_en);
      }else{
        setMissionName(currentMissionData.main_question.title_nl);
      }
      
    }
    
  }, [currentMissionData]);

  useEffect(() => {
    return () => {
      clearTimeout(timeOut);
    }
  }, []);

  const getUserById = (id) => {
    return players.filter((player) => player.secret === id);
  }

  const otherPlayerName = players.reduce((filtered, player) => {
    if(player.secret !== cookiePlayerId){
      filtered.push(player.name);
    }
    return filtered;
  }, []);

  return (
    <div className={`mission-wrapper ${lifted ? 'lift' : ''}`} ref={ e => { missionWrapperRef = e }}>
      <div className={`mission animateIn ${lifted && !missionEnd ? 'asBackground' : ''}`} ref={ e => { missionRef = e }}>
        <div className="missionCircle outer"></div>
        <div className={`missionCircle number ${lifted ? 'active' : ''}`}>
          <div className="numberContainer">{currentMission + 1}</div>
          <div className="descriptionContainer">{ t("student.game_overview.mission")}</div>
        </div>
        <StarFX suspendFX={miniGameActive && !missionEnd ? true : false}/>
      </div>
    
      <div className={`user-overview animateIn ${missionEnd ? 'missionEndAnimation' : ''}`}>
        <div className={`statusRow mainMissionAccent ${currentMissionData && cookiePlayerId === currentMissionData.main_question_player ? 'activePlayer' : ''}`}>
              <div className="teamMember" >
                { currentMissionData && 
                  cookiePlayerId === currentMissionData.main_question_player && 
                  <p style={ { color: mainQuestionPlayerColor}}>{t("student.questions_overview.you")}</p> 
                }
                {
                  currentMissionData && 
                  cookiePlayerId !== currentMissionData.main_question_player && 
                  getUserById(currentMissionData.main_question_player).map(player => (
                    <p style={ { color: mainQuestionPlayerColor}} key={player.secret}>{player.name}</p>
                  ))
                }
              </div>
              <div className={`rewardContainer ${missionSuccess ? 'succes' : 'no'}`}></div>
              <div className="assignment">{t("student.questions_overview.mystery")}</div>
          </div>
          <div className={`statusRow ${currentMissionData && cookiePlayerId === currentMissionData.mix_n_match_player ? 'activePlayer' : ''}`}>
              <div className="teamMember" >
                { currentMissionData && 
                  cookiePlayerId === currentMissionData.mix_n_match_player && 
                  <p style={ { color: mixNMatchPlayerColor}}>{t("student.questions_overview.you")}</p>
                }
                {
                  currentMissionData && 
                  cookiePlayerId !== currentMissionData.mix_n_match_player && 
                  getUserById(currentMissionData.mix_n_match_player).map(player => (
                    <p key={player.secret} style={ { color: mixNMatchPlayerColor}}>{player.name}</p>
                  ))
                }
              </div>
              <div className={`rewardContainer ${currentMissionData.mix_n_match_finished ? 'succes' : 'no'}`}></div>
              <div className="assignment">{t("student.questions_overview.mix_n_match")}</div>
          </div>
          <div className={`statusRow ${currentMissionData && cookiePlayerId === currentMissionData.swipe_player ? 'activePlayer' : ''}`}>
              <div className="teamMember" >
                { currentMissionData && 
                  cookiePlayerId === currentMissionData.swipe_player && 
                  <p style={ { color: swipePlayerColor}}>{t("student.questions_overview.you")}</p>
                }
                {
                  currentMissionData && 
                  cookiePlayerId !== currentMissionData.swipe_player && 
                  getUserById(currentMissionData.swipe_player).map(player => (
                    <p key={player.secret} style={ { color: swipePlayerColor}}>{player.name}</p>
                  ))
                }
              </div>
              <div className={`rewardContainer ${currentMissionData.swipe_finished ? 'succes' : 'no'}`}></div>
              <div className="assignment">{t("student.questions_overview.swipe")}</div>
          </div>
      </div>
    
      {!missionOnly && 
         <div className={`mission-overview frameSimple blackNightsTheme animateIn ${missionEnd ? 'end' : ''}`} ref={ e => { missionOverviewRef = e }}>
          { !missionEnd && 
            <>
            <h2>{ t("student.game_overview.mission")} {currentMission + 1}</h2>
            {playerCount === 3 && cookiePlayerId === currentMissionData.main_question_player && <p>{t("student.game_overview.main_question_description", [missionName, ...otherPlayerName])}</p>}
            {playerCount === 4 && cookiePlayerId === currentMissionData.main_question_player && <p>{t("student.game_overview.main_question_description_extra", [missionName, ...otherPlayerName])}</p>}
            {playerCount === 3 && cookiePlayerId !== currentMissionData.main_question_player && <p>{t("student.game_overview.other_question_description", [missionName, ...otherPlayerName])}</p>}
            {playerCount === 4 && cookiePlayerId !== currentMissionData.main_question_player && <p>{t("student.game_overview.other_question_description_extra", [missionName, ...otherPlayerName])}</p>}
            </>
          }
        </div>
      }
    </div>
  )
}

export default Mission;